<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  import browser from "@/utils/browser";

  export default {
    name: "App",
    data: function () {
      return {
        uaInfo: "",
        statusBar: 0,
        isIOS: false,
      };
    },
    mounted: function () {
      //获取状态栏高度
      let data = {};
      let self = this;
      if (browser.isAndroid()) {
        console.log("getAndroidStatusBarHeight");
        window.connectWebViewJavascriptBridge(function (bridge) {
          bridge.callHandler(
            "getAndroidStatusBarHeight",
            data,
            function (response) {
              console.log("设置安卓状态栏高度" + response);
              alert(response)
              let resp = JSON.parse(response);
              self.statusBar = resp.height;
              
            }
          );
        });
      } else {
        self.isIOS = true;
        // console.log(
        //   "xxx" +
        //     getComputedStyle(document.documentElement).getPropertyValue("--sat")
        // );
        // self.statusBar = getComputedStyle(
        //   document.documentElement
        // ).getPropertyValue("--sat");
      }

      // sensors.quick('isReady', function () {
      //   sensors.getPresetProperties();
      // });
    },
    computed: {
      styleObject: function () {
        return {
          // "padding-top": "30px",
          // "padding-top": this.statusBar + 44 + "px",
        };
      },
    },
  };
</script>

<style>
  #__vconsole {
    display: none;
  }

  .show {
    display: block !important;
  }

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    background-color: #efefef;

    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Chrome/Safari/Opera */
    -khtml-user-select: none;
    /* Konqueror */
    -moz-user-select: none;
    /* Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently not supported by any browser */
    /* padding-top: 60px; */
  }

  .ios {
    padding-top: calc(80px + env(safe-area-inset-top)) !important;
    padding-top: calc(80px + contain(safe-area-inset-top)) !important;
  }
</style>